<template>
	<v-container>
		<alert-basic :show="alert.show" :message="alert.message" :type="alert.type" />

		<div class="panel">
			<user-details-form :selected-user="selectedUser" @saved="onUserDetailsSaved" @error="onChildError" />
		</div>

		<div class="panel">
			<general-rights-editor :rights="rights" :selected-user="selectedUser" @deleteRight="onDeleteRight"
				@rightAdded="onRightAdded" @confirmedEditRight="onConfirmedEditRight" @error="onChildError" />
		</div>

		<div class="panel">
			<power-bi-specific-rights-table class="power-bi-rights-table-edit" :selected-user="selectedUser"
				@rightAdded="onPowerBiRightAdded" @rightDeleted="onPowerBiRightDeleted" />
		</div>
	</v-container>
</template>

<script>
import UserDetailsForm from './UserDetailsForm.vue'
import GeneralRightsEditor from './GeneralRightsEditor.vue'
import PowerBiSpecificRightsTable from './PowerBiSpecificRightsTable.vue'
import AlertBasic from '../../vueBasics/AlertBasic.vue'

export default {
	name: 'UserRightsOverview',
	components: {
		UserDetailsForm,
		GeneralRightsEditor,
		PowerBiSpecificRightsTable,
		AlertBasic,
	},
	props: {
		rights: { type: Array, required: true },
		selectedUser: { type: Object, required: true },
	},
	data() {
		return {
			alert: {
				message: '',
				show: false,
				type: 'info',
			},
		}
	},
	methods: {
		showAlert(type, message) {
			clearTimeout(this.alertTimer)
			this.alert = { show: true, type, message }
			this.alertTimer = setTimeout(() => { this.alert.show = false }, 6000)
		},
		onChildError(error) {
			const message = (error && error.response && error.response.data && error.response.data.message) || (error && error.response && error.response.data) || 'An error occurred'
			this.showAlert('error', message)
		},
		onUserDetailsSaved() {
			this.showAlert('success', 'User details saved')
			this.$emit('userDetailsSaved')
		},
		onRightAdded() {
			this.showAlert('success', 'Right added successfully')
			this.$emit('rightAdded')
		},
		onDeleteRight(item) {
			this.showAlert('success', 'Right deleted successfully')
			this.$emit('deleteRight', item)
		},
		onConfirmedEditRight(data) {
			this.showAlert('success', 'Right updated successfully')
			this.$emit('confirmedEditRight', data)
		},
		onPowerBiRightAdded() {
			this.showAlert('success', 'Power BI right added successfully')
		},
		onPowerBiRightDeleted() {
			this.showAlert('success', 'Power BI right deleted successfully')
		},
	},
}
</script>

<style lang="scss" scoped>
@import '../../../../src/assets/scss/styling';

.dividerNewRights {
	margin-top: 25px;
	margin-bottom: 10px;
}

.power-bi-rights-table-edit {
	margin: 0 auto;
	width: 80%;
	margin-bottom: 30px !important;
}

.panel {
	padding: 20px;
	margin-bottom: 20px;
	border-radius: 5px;
	box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
}
</style>
